import { AreaResource, AreaType } from '../../area.resource';
import { BaseModel } from '../model/area-zucchetti.model';

export class AreaZucchettiResource extends AreaResource {
  public static readonly TYPE =  AreaType.zucchetti;

  
  type_user: TypeUserResource;
  society:SocietyResource[];
  operational_function:OperationalFunctionResource[];
  notes: string; 
  constructor() {
    super(AreaZucchettiResource.TYPE);
  }
}

export class BaseResource{
  links:any[];
  id: number;
  value:string;
  description:string;

  setJson(json:BaseModel){
    this.id = json.id;
    this.value = json.value;
    this.description = json.description;
    this.links = json.links;
  }
}
export class TypeUserResource extends BaseResource{}
export class SocietyResource extends BaseResource{}
export class OperationalFunctionResource extends BaseResource{}


